class CartRecsSwiper extends HTMLElement {
  connectedCallback() {
    this.initWhenReady();
  }

  initWhenReady(attempt = 0) {
    if (this.swiper) return;
    const container = this.querySelector('.swiper');
    if (!container) return;

    if (typeof Swiper === 'undefined') {
      if (attempt < 40) setTimeout(() => this.initWhenReady(attempt + 1), 50);
      return;
    }

    this.swiper = new Swiper(container, {
      slidesPerView: 1.5,
      spaceBetween: 8,
      slidesOffsetBefore: 16,
      slidesOffsetAfter: 16,
      grabCursor: true,
      watchOverflow: true,
      observer: true,
      observeParents: true,
      a11y: false,
    });

    requestAnimationFrame(() => this.swiper?.update());
    window.addEventListener('load', () => this.swiper?.update(), { once: true });
    this.addEventListener('mouseenter', () => this.swiper?.update(), { passive: true });
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
    this.swiper = null;
  }
}

if (!customElements.get('cart-recs-swiper')) {
  customElements.define('cart-recs-swiper', CartRecsSwiper);
}
